export type SmtpSettingsDefault = {
    configurationType: -1
    config: undefined
}

export type SmtpSettingsBasic = {
    /** Basic */
    configurationType: 0
    /** Custom SMTP settings */
    config: SmtpOptions
}

export type SmtpSettingsOfficePublic = {
    /** Office 365 Public */
    configurationType: 1
    /** Azure public app settings */
    config: Office356PublicAppOptions
}

export type SmtpSettingsOfficeConfidential = {
    /** Office 365 Confidential */
    configurationType: 2
    /** Azure confidential app settings */
    config: Office356ConfidentialAppOptions
}

export type ISmtpSettings =
    | SmtpSettingsDefault
    | SmtpSettingsBasic
    | SmtpSettingsOfficePublic
    | SmtpSettingsOfficeConfidential

export const SmtpSettingsConfigType = {
    Default: -1,
    Basic: 0,
    Office365Public: 1,
    Office365Confidential: 2,
} as const

export type SmtpSettingsConfigType = typeof SmtpSettingsConfigType[keyof typeof SmtpSettingsConfigType]

export type SmtpOptions = {
    /** A string that contains the name or IP address of the host computer used for SMTP transactions. */
    Server: string
    /** Port number on the SMTP host. The default value is 25 */
    Port?: number
    /** Specify whether the SmtpClient uses Secure Sockets Layer (SSL) to encrypt the connection.  */
    UseSsl: boolean
    /** A string that contains an email address */
    From: string
    /** A string that contains the display name associated with address. */
    Display: string
    /** The username associated with the credentials to send an e-mail */
    User:string
    /** The password for the username associated with the credentials to send an e-mail */
    Password:string
}

export type Office356PublicAppOptions = {
    /** Tenant id on Azure */
    TenantId: string
    /** Application id on Azure */
    ClientId: string
    /** Redirect uri defined  */
    RedirectUri: string
    /** Email address to send email from */
    AccountName: string
    /** MSAL token */
    Token: string
}

export type Office356ConfidentialAppOptions = {
    /** Tenant id on Azure */
    TenantId: string
    /** Application id on Azure */
    ClientId: string
    /** Secret generated for confidential app */
    Secret: string
    /** Expiration date time of the secret */
    ExpiresOn: Date
    /** Email address to send email from */
    AccountId: string
}